import { DeepMap, FieldError } from 'react-hook-form'

import { SupportRequestNewInput } from '../../../graphql/camel'
import { FormValues } from './types'

type SupportRequestFormValues = Omit<SupportRequestNewInput, 'attachmentUrls' | 'ccEmails' | 'type'>

export const formattedTicketFormValues = (formValues: FormValues): SupportRequestFormValues => {
  const { name, email, subject, details } = formValues
  return {
    subject: subject.trim(),
    details: details.trim(),
    requesterName: name.trim(),
    requesterEmail: email.trim(),
  }
}

export const requiredFieldsErrorMessage = ({
  name,
  email,
  subject,
  details,
}: DeepMap<FormValues, FieldError>): string => {
  const capitalizedErrorMessage = (message: string) =>
    message.charAt(0).toUpperCase() + message.slice(1)
  const requiredErrorMessage = 'required to open a support request'
  const reducedFieldsRequiredError = [{ name }, { email }, { subject }, { details }]
    .filter((field) => !!Object.values(field)[0])
    .reduce((acc: string, field, index, array) => {
      const isFieldRequiredError = Object.values(field)[0]?.type === 'required'
      if (isFieldRequiredError) {
        if (index === array.length - 1) {
          return `${acc ? acc + ' and ' : ''}${Object.keys(field)[0]} ${acc ? 'are' : 'is'} ${requiredErrorMessage}`
        }
        return `${acc}${Object.keys(field)[0]}${array.length > 2 ? ', ' : ' '}`
      }
      return acc
    }, '')
  return capitalizedErrorMessage(reducedFieldsRequiredError)
}
